export default {
  INIT_USER_CENTER: 'INIT_USER_CENTER',
  GET_USER_INFO: 'GET_USER_INFO',
  INIT_USER_MENU: 'INIT_USER_MENU',
  CHECK_ROLE: 'CHECK_ROLE',
  // GET_APP_LIST: 'GET_APP_LIST',
  GET_APP_TYPES: 'GET_APP_TYPES',
  GET_APP: 'GET_APP',
  // GET_APP_TYPE_LIST: 'GET_APP_TYPE_LIST',
  SET_CURRENT_APP: 'SET_CURRENT_APP',
  CHANGE_CURRENT_ENTRY: 'CHANGE_CURRENT_ENTRY',
  CHANGE_ENTRY_LIST: 'CHANGE_ENTRY_LIST',
  INIT_MANAGE_SIDEBAR: 'INIT_MANAGE_SIDEBAR',
  CHANGE_MANAGE_SIDEBAR: 'CHANGE_MANAGE_SIDEBAR',
  INIT_RENDER: 'INIT_RENDER',
  // GET_MP: 'GET_MP',
  // UPDATE_MP: 'UPDATE_MP',

  // RIO
  GET_SYSTEM_LIST: 'GET_SYSTEM_LIST',
  CHANGE_SYSTEM: 'CHANGE_SYSTEM',
};
